import axiosInstance from '../api/axiosInstance';
import { Owner, OwnerListResponse } from '../models/Owner';

export class OwnerRepository {
    static async getAll(): Promise<OwnerListResponse> {
        const response = await axiosInstance.get<OwnerListResponse>('/admin/users');
        return response.data;
    }

    static async getById(id: number): Promise<{ status: string, data: Owner }> {
        const response = await axiosInstance.get<{ status: string, data: Owner }>(`/admin/users/${id}`);
        return response.data;
    }

    static async create(formData: FormData): Promise<{ status: string, message: string, data: Owner }> {
        const response = await axiosInstance.post('/admin/users', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    }

    static async update(id: number, formData: FormData): Promise<{ status: string, message: string, data: Owner }> {
        // Use POST with method spoofing for Laravel file support on PUT
        formData.append('_method', 'PUT');
        const response = await axiosInstance.post(`/admin/users/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    }

    static async delete(id: number): Promise<{ status: string, message: string }> {
        const response = await axiosInstance.delete(`/admin/users/${id}`);
        return response.data;
    }
}
